<ion-header>
	<app-account-toolbar (back)="goBack()" src="/assets/icons/barrierefreiheit.svg" title="Barrierefreiheit"></app-account-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<section class="bfsg-declaration">
		<p>Barrierefreiheitserklärung</p>
		<p>Stand: 27. Juni 2025</p>
		<p>
			Die dean&amp;david Franchise GmbH verpflichtet sich, ihre digitalen Produkte im Einklang mit dem
			Barrierefreiheitsstärkungsgesetz (BFSG), der EU-Richtlinie 2019/882 (European Accessibility Act) sowie der Norm EN 301 549
			barrierefrei zugänglich zu machen.
		</p>
		<p>Diese Erklärung gilt für folgende digitale Angebote: Alle Webseiten, Webshops sowie native Apps.</p>
		<h3>1. Stand der Barrierefreiheit</h3>
		<p>
			Unsere digitalen Angebote erfüllen derzeit nicht vollständig die gesetzlichen Anforderungen an Barrierefreiheit. Darüber hinaus
			bestehen noch zahlreiche Barrieren, die eine gleichberechtigte Nutzung für Menschen mit Einschränkungen verhindern.
		</p>
		<p>
			Die Umsetzung weiterer Maßnahmen ist geplant, wurde bislang jedoch aus technischen und strukturellen Gründen noch nicht
			realisiert
		</p>
		<h3>2. Zeitnah umgesetzte Maßnahmen (geplant)</h3>
		<h4>
			Funktionen zur Verbesserung der Barrierefreiheit sind aktuell nicht vorhanden, werden jedoch vorrangig im Rahmen der geplanten
			Maßnahmen umgesetzt:
		</h4>
		<ul>
			<li>Eine Tastaturnavigation für das Hauptnavigationssystem</li>
			<li>Keine individuellen Anpassungen von Schriftgröße, Kontrast, Zeilenhöhe oder Farbsättigung</li>
			<li>Keine Möglichkeit, eine dyslexiefreundliche Schriftart zu aktivieren</li>
			<li>Keine Speicherung individueller Einstellungen beim Seitenwechsel</li>
			<li>Keine alternative Darstellung zur Reduktion sensorischer Reize (z. B. Animationen deaktivieren)</li>
			<li>Keine optimierte Darstellung oder Bedienbarkeit auf mobilen Endgeräten</li>
			<li>Keine persistente Anwendung benutzerspezifischer Einstellungen</li>
			<li>Keine visuelle Rückmeldung bei Nutzeraktionen (z. B. Formularversand)</li>
		</ul>
		<p>
			Hinweis zur Screenreader-Bedienung: Unsere digitalen Angebote sind derzeit nur eingeschränkt mit Screenreadern nutzbar. Es
			fehlen strukturierte Auszeichnungen und unterstützende Informationen, die für eine barrierefreie Nutzung erforderlich sind.
		</p>

		<h3>3. Bestehende Barrieren und geplante Schritte</h3>
		<h4>Derzeit bestehen zahlreiche bekannte Barrieren in folgenden Bereichen:</h4>

		<h4>Formulare:</h4>
		<ul>
			<li>Fehlende oder fehlerhafte Verknüpfung von Label-Elementen</li>
			<li>Nicht barrierefreie Fehlermeldungen</li>
			<li>Formularelemente ohne zugehöriges Label</li>
			<li>Buttons/Eingabefelder ohne zugängliche Namen</li>
		</ul>

		<h4>Interaktive Elemente:</h4>
		<ul>
			<li>Buttons unterhalb der Mindestgröße (48 × 48 CSS-Pixel)</li>
			<li>Fehlende oder nicht identifizierbare Namen bei Schaltflächen</li>
			<li>Fehlende ARIA-Attribute oder fehlerhafte Rollenstruktur</li>
		</ul>

		<h4>HTML-Struktur & Semantik:</h4>
		<ul>
			<li>Nicht-konsequente Nutzung semantischer HTML-Container</li>
			<li>Fehlerhafte Überschriftenhierarchie</li>
			<li>Doppelte oder unklare ID-Zuweisungen</li>
			<li>Fehlende Sprachangabe (z. B. lang="de" im HTML-Tag)</li>
			<li>Listenelemente nicht korrekt verschachtelt</li>
		</ul>

		<h4>Navigation:</h4>
		<ul>
			<li>Inkonsistente Menü- und Footer-Struktur</li>
			<li>Dialoge ohne zugängliche Namen (z. B. fehlendes aria-label)</li>
		</ul>

		<h4>Visuelles Feedback:</h4>
		<ul>
			<li>Fehlendes Feedback bei Benutzeraktionen (z. B. Formularabsendungen)</li>
			<li>Ladeindikatoren nicht immer vorhanden oder sichtbar</li>
		</ul>

		<h4>Zoom & Skalierung:</h4>
		<ul>
			<li>user-scalable="no" in der Viewport-Konfiguration verhindert Vergrößerung</li>
			<li>Einschränkungen auf mobilen Geräten</li>
		</ul>

		<h4>Bilder & Icons:</h4>
		<ul>
			<li>Fehlende alt-Attribute bei Bildern und Icons</li>
			<li>Dekorative Bilder nicht korrekt als solche gekennzeichnet</li>
		</ul>

		<h4>Schriftarten:</h4>
		<ul>
			<li>Keine barrierefreie Schriftart wie z. B. OpenDyslexic im Einsatz</li>
		</ul>

		<h4>Multimedia-Inhalte:</h4>
		<ul>
			<li>Keine Audiodeskriptionen oder Transkripte bei Videos</li>
			<li>Animierte Inhalte nicht screenreaderfreundlich</li>
		</ul>

		<h4>PDF-Dokumente:</h4>
		<ul>
			<li>Nur teilweise barrierefrei</li>
			<li>Fehlende semantische Struktur, Lese-Reihenfolge, Alternativtexte etc.</li>
		</ul>

		<h3>4. Hintergrund zu den verbleibenden Barrieren</h3>
		<p>
			Einzelne Anforderungen konnten bislang aufgrund technischer Komplexität, bestehender Systemabhängigkeiten sowie begrenzter
			Ressourcen noch nicht vollständig umgesetzt werden.
		</p>
		<p>
			Zudem kommt es regelmäßig zu technischen Schwierigkeiten, die eine einheitliche Umsetzung auf allen Webpräsenzen gleichzeitig
			erschweren. In der Vergangenheit kam es vor, dass durch technische Anpassungen im Backend zentrale Elemente auf einzelnen Seiten
			unbeabsichtigt beschädigt wurden.
		</p>
		<p>
			Wir sind uns dieser Herausforderungen bewusst und arbeiten kontinuierlich und mit hoher Priorität daran, eine stabile und
			barrierefreie Lösung bereitzustellen, die für alle Seiten funktioniert – ohne bestehende Strukturen zu gefährden.
		</p>

		<h3>5. Feedback und Kontakt</h3>
		<p>Wir freuen uns über Ihre Hinweise zur Verbesserung der Barrierefreiheit.</p>

		<h4>Kontakt:</h4>
		<p>
			Tel.: +49 89 26 20 59 410<br />
			E-Mail: info&#64;deananddavid.com <br />
		</p>

		<h4>Postanschrift:</h4>
		<p>
			Lohenstra&szlig;e 8<br />
			82166 Gr&auml;felfing<br />
			Deutschland<br /><br />
			Wir bemühen uns, alle barrierebezogenen Anfragen innerhalb von fünf Werktagen zu beantworten.
		</p>

		<h3>6. Durchsetzungsverfahren</h3>
		<h4>Falls Sie keine zufriedenstellende Rückmeldung erhalten, können Sie sich an die zuständige Schlichtungsstelle wenden:</h4>
		<p>
			Schlichtungsstelle BGG<br />
			bei der Beauftragten der Bundesregierung für die Belange von Menschen mit Behinderungen<br />
			Mauerstraße 53, 10117 Berlin<br /><br />
			E-Mail: info&#64;schlichtungsstelle-bgg.de<br />
			Web: www.schlichtungsstelle-bgg.de
		</p>

		<h3>7. Aktualität dieser Erklärung</h3>
		<p>
			Diese Erklärung wurde am 27. Juni 2025 erstellt. Sie wird regelmäßig überprüft und angepasst, sobald Maßnahmen zur Verbesserung
			der Barrierefreiheit umgesetzt wurden.
		</p>
	</section>
</ion-content>
